import { Component, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-lead-time-chart',
  templateUrl: './lead-time-chart.component.html',
  styleUrls: ['./lead-time-chart.component.scss']
})
export class LeadTimeChartComponent {
    @ViewChild('scrollContainer') scrollContainer!: ElementRef;
     isMobileView = window.innerWidth <= 1024;
  @Input() data:any;
  @Input() id:any;
  @Input() Title:any;
  ngAfterViewInit()
  {

    const analysis_daily_opt:any = document.getElementById("canvas__"+this.id);
    const analysis_daily_ctx = analysis_daily_opt.getContext('2d');

    let chartStatus = Chart.getChart(this.id); // <canvas> id
    if (chartStatus != undefined) {
      chartStatus.destroy();
    
      
    }
    var _labels = [];
    var values = [];
    if(this.data)
    {
      for (var key in this.data) {
        _labels.push(key);
        values.push(Number(this.data[key]) || 0);
      }
    }


    let myChart2 = new Chart(analysis_daily_ctx, {
      type: 'line',
       data : {
        labels: _labels,
        datasets: [{
          data: values,
          borderWidth: 3, // Setting the width to 3px
          borderColor: '#F0950C', // Setting the line color
         
      }]
      },
      
      options: {
        animation: {
          duration: 1,
          onComplete: function({ chart }) {
            const ctx = chart.ctx;
        
            chart.config.data.datasets.forEach(function(dataset, i) {
              const meta = chart.getDatasetMeta(i);
        
              meta.data.forEach(function(bar, index) {
                const data:any = dataset.data[index];
                console.log(data)
        
                // ctx.fillText(data, bar.x, bar.y - 5);
              });
            });
          }
        },
        plugins: {
        
          legend: {
              display: false
          },
      },
        responsive: false,
        scales: {
          y: {
            beginAtZero: true,
            suggestedMax: 5,
            ticks: {
              precision: 0
            }
          }
        }
      },
    })
  
  }


@HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = window.innerWidth <= 1024;
  }

handleScrollLeft()  {
  const container = this.scrollContainer.nativeElement;
  container.scrollBy({ left: -150, behavior: 'smooth' });
}

handleScrollRight() {
  const container = this.scrollContainer.nativeElement;
  container.scrollBy({ left: 150, behavior: 'smooth' });
}
}
